<template>
  <div>
    <!-- breadcrumb start -->
    <breadcrumb-one
      banner_height="page-banner-height-2"
      title="My account"
      subtitle="My account"
    ></breadcrumb-one>
    <!-- breadcrumb end -->
  
    <!-- My account area start -->
    <div class="account-area mt-70 mb-70">
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <div class="basic-login mb-50">
              <h5>Login</h5>
              <!-- Conditionally show the login form if the user is not logged in -->
              <form-login v-if="!isLoggedIn"></form-login>
              <p v-else>You are already logged in!</p>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="basic-login">
              <h5>Register</h5>
              <form-register></form-register>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- My account area end -->
  
    <!-- cta area start -->
    <cta-area></cta-area>
    <!-- cta area end -->
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import BreadcrumbOne from '@/components/breadcrumb/breadcrumb-one.vue';
import FormLogin from '@/components/form/form-login.vue';
import FormRegister from '@/components/form/form-register.vue';
import CtaArea from '@/components/cta/cta-area.vue';

export default defineComponent({
  name: 'MyAccountPage',
  components: {
    BreadcrumbOne,
    FormLogin,
    FormRegister,
    CtaArea,
  },
  data() {
    return {
      isLoggedIn: false, // Track if the user is logged in
    };
  },
  created() {
    // Check if the user is logged in by checking for an auth token
    this.isLoggedIn = !!localStorage.getItem('auth_token') || !!sessionStorage.getItem('auth_token');
  },
});
</script>

<style scoped>
/* Add any scoped CSS styles if required */
</style>
